import React from "react";
import { EditDealerContextProvider } from "./EditDealerView";
import EditDealer from "./views/EditDealer";

const EditDealerPage = () => {
  return (
    <EditDealerContextProvider>
      <EditDealer />
    </EditDealerContextProvider>
  );
};

export default EditDealerPage;
